<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
    <div class="form-row mx-1">
        <label [for]="idHtml" class="form-label">{{libelle$ | async }} </label>
        <p class="text-muted" *ngIf="currentControl.value.length > 0"> ({{ currentControl.value.length }} choix
            sélectionnés)</p>
        <mat-form-field class="col-12" *ngIf="! afficherEnLectureSeule">
            <mat-select  [matTooltip]="this.listeSelectionnee" matTooltipClass="tooltip-large" [class.is-warning]="aErreurCroiseeActive()"
            [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()" [formControl]="currentControl" class="col-12"
            multiple>
               <!--  <mat-select-trigger>
                    {{currentControl.value ? currentControl.value[0] : ''}}
                    <span *ngIf="currentControl.value?.length > 1" class="example-additional-selection">
                        (+{{currentControl.value.length - 1}} {{currentControl.value?.length === 2 ? 'other' : 'others'}})
                    </span>
                </mat-select-trigger> -->
                <mat-option *ngFor="let modalite of modalites$ | async" [value]="modalite.code">{{ modalite.libelle }}</mat-option>
            </mat-select>
        </mat-form-field>
        <div *ngIf="afficherEnLectureSeule" class="col-12">
            <input [class.is-warning]="aErreurCroiseeActive()"
            [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()"
            class="form-control col-12" readonly [value]="this.listeSelectionnee" />
        </div>
        <!-- TODO afficher directement l’erreur si obligatoire -->
        <bis-affiche-erreurs class="col-12" *ngIf="erreursAffichable()" [erreurs]="rootForm.get(label).errors">
        </bis-affiche-erreurs>
    </div>
</form>